export enum RouteTypeEnum {
  MAIN = 'MAIN',
  TRUSTED = 'TRUSTED',
}
